"use client";

import { c as _c } from "react/compiler-runtime";
import { OfferType } from "@opensea/graphql";
import { toLowerCase, toUpperCase } from "@opensea/utils";
import { parseAsArrayOf, parseAsStringLiteral, useQueryState } from "nuqs";
import { EXCLUDED_OFFER_TYPES } from "@/components/offers/ProfileOffers/constants";
import { QUERY_PARAM_KEYS } from "./keys";
const validOfferTypes = OfferType.filter(t => !EXCLUDED_OFFER_TYPES.includes(t)).map(t => toLowerCase(t));
const parser = parseAsStringLiteral(validOfferTypes);
export function useOfferTypeQueryParam() {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsArrayOf(parser).withDefault([]);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [values, setValues] = useQueryState(QUERY_PARAM_KEYS.offerTypes, t0);
  let t1;
  if ($[1] !== setValues || $[2] !== values) {
    t1 = async function onSelectOfferType(type) {
      const parsed = toLowerCase(type);
      const newValues = values.includes(parsed) ? values.filter(v => v !== parsed) : [...values, parsed];
      await setValues(newValues.length > 0 ? newValues : null);
    };
    $[1] = setValues;
    $[2] = values;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onSelectOfferType = t1;
  let t2;
  if ($[4] !== values) {
    t2 = values.map(_temp);
    $[4] = values;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== setValues) {
    t3 = () => setValues([], {
      clearOnDefault: true
    });
    $[6] = setValues;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onSelectOfferType || $[9] !== t2 || $[10] !== t3) {
    t4 = {
      offerTypes: t2,
      onSelectOfferType,
      clearOfferTypes: t3
    };
    $[8] = onSelectOfferType;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function _temp(v_0) {
  return toUpperCase(v_0);
}